import { axiosCms } from 'Axios.js';
import { authToken } from '../utility';
import * as actionTypes from './actionTypes';

const fetchProductTypesStart = () => ({ type: actionTypes.FETCH_PRODUCT_TYPES_START });

const fetchProductTypesEnd = data => ({ type: actionTypes.FETCH_PRODUCT_TYPES_END, data });

export const fetchProductTypes = () => {
  return dispatch => {
    dispatch(fetchProductTypesStart());

    axiosCms.defaults.headers.common['Authorization'] = dispatch(authToken());

    return axiosCms
      .get('/product_types')
      .then(response => {
        const { data } = response;
        dispatch(fetchProductTypesEnd(data));
      })
      .catch(err => {
        console.error(`fetchProductTypes err: `, err);
        return Promise.reject(err);
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/product_types.js